module.exports = "/davinci/assets/421471f8b43160bc1d6f4ac784882758.jpg";